<template>
    <div>
        <h4 style="text-align: center">รายงานสินค้า (รายเดือน)</h4>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">
                เดือนที่ต้องการออกรายงาน
            </div>
            <div class="col-6">
                <date-picker v-model="form.month"
                             type="month"
                             format="MM/YYYY"
                             :lang="lang"
                             placeholder="เลือกเดือน">
                </date-picker>
            </div>
        </div>
        <div class="col text-center">
            <button class="btn btn-success" @click="submitData">พิมพ์</button>&nbsp;
            <button class="btn btn-outline-secondary" @click="cancelData">ยกเลิก</button>&nbsp;
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
    name: "reportProductSale",
    components: {
        DatePicker,
    },
    data() {
        return {
            form: {
                month: '',
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        submitData() {
            if (!this.form.month) {
                alert('กรุณาเลือกเดือน');
            } else {
                this.$emit("submit", this.form);
            }
        },
        cancelData() {
            this.$emit("submit", false);
        },
    }
}
</script>

<style scoped>

</style>
